import { makeStyles } from "@material-ui/core/styles";

const useBrandGroupSingleEditDialogStyles = makeStyles(
  {
    assignBrands: {
      "& .MuiTypography-h6": {
        fontSize: "16px",
        fontWeight: "bold"
      }
    },
    buttonAction: {
      "& .MuiButton-root": {
        color: "#0030FF"
      },
      "& .MuiButton-text & .MuiButton-label": {
        color: "#0030FF"
      }
    },
    colName: {
      fontWeight: "bold",
      paddingLeft: 0,
      width: "25%"
    },
    colPrice: {
      fontWeight: "bold",
      textAlign: "left"
    },
    colStoreName: {
      paddingLeft: 0,
      width: "25%"
    },
    discountContent: {
      "& .MuiDialogContent-root": {
        padding: 0
      }
    },
    selectBrands: {
      fontWeight: "bold",
      marginBottom: "10px"
    },
    selectedSellerName: {
      color: "#1844ff",
      fontSize: "18px",
      fontWeight: "bold"
    },
    sellerList: {
      marginBottom: "100px"
    },
    sellerName: {
      fontSize: "12px"
    },
    storeText: {
      "&:hover": {
        color: "#fff"
      }
    }
  },
  { name: "brandGroupDialog" }
);

export default useBrandGroupSingleEditDialogStyles;
